import React from 'react';

const About = () => {
  const features = [
    'Direct payments to dance school accounts',
    '1.2% commission on-demand basis only',
    'No fees charged to parents',
    'Reward system for loyal customers'
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About FeeZaap</h2>
            <p>
              FeeZaap is developed by <strong>Napeans Technologies</strong>, a GST-registered IT company operating since 2019. We specialize in creating innovative digital solutions that simplify complex business processes.
            </p>
            <p>
              Our mission is to digitize fee management for dance schools across India, making it easier for administrators to manage batches, staff, and students while providing parents with a seamless payment experience.
            </p>

            <div className="about-features">
              {features.map((feature, index) => (
                <div key={index} className="about-feature">
                  <i className="fas fa-check-circle"></i>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="about-image">
            <img src="/assets/images/feezaap-logo.png" alt="FeeZaap Brand Logo and Identity" className="about-logo" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
